import { StyleSheet, Dimensions } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

const { width, height } = Dimensions.get('window');

export default StyleSheet.create({
  sectionTitle: theme => ({
    color: theme.colors.headerTitleColor,
    fontSize: 24,
    fontWeight: '300',
    marginBottom: 40,
    paddingLeft: 16,
    fontFamily: Fonts.type.VFFont,
    marginTop: 6,
  }),
  amountSectionTitle: theme => ({
    color: theme.colors.headerTitleColor,
    fontSize: 24,
    fontWeight: '300',
    paddingLeft: 16,
    fontFamily: Fonts.type.VodafoneLt,
    marginBottom: 12,
    marginTop: 20,
    lineHeight: 32,
  }),
  paymentTypeOptionsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
  },
  paymentAmountOptionsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
  },
  moreThanThreeOptionsContainer: {
    paddingHorizontal: 16,
  },
  mainTitleTextStyle: (theme, isActive, subTitle) => ({
    fontSize: 18,
    fontFamily: isActive ? Fonts.type.bold.fontFamily : Fonts.type.VFFont,
    fontWeight: isActive ? Fonts.type.bold.fontWeight : '100',
    color: isActive ? theme.colors.activeColor : theme.colors.textColorThree,
    marginTop: subTitle ? 5 : 0,
    lineHeight: 25,
  }),
  subTitleTextStyle: (theme, isActive) => ({
    fontSize: 14,
    color: isActive ? theme.colors.activeColor : theme.colors.textColorThree,
    fontWeight: isActive ? Fonts.type.bold.fontWeight : '100',
    lineHeight: 18,
    marginTop: 8,
  }),
  oneOptionStyle: {
    width: '100%',
  },
  twoOptionStyle: {
    width: '48%',
  },
  threeOptionStyle: {
    width: '32%',
  },
  moreThanThreeOptionsStyle: {
    width: width * 0.267,
    height: height * 0.0925,
    marginRight: width * 0.015,
  },
  paymentMethodDescriptionStyle: theme => ({
    fontSize: 18,
    fontWeight: '300',
    color: theme.colors.textColorThree,
    marginTop: 16,
    lineHeight: 28,
    minHeight: 54,
  }),
  confirmButtonTextStyle: theme => ({
    color: theme.colors.textButtons.primary.default,
    fontSize: 18,
    fontFamily: Fonts.type.VFFont,
    marginTop: 3,
  }),
  successBtnDisabled: theme => ({
    backgroundColor: theme.colors.buttons.disabled,
  }),
  successBtnDisabledText: theme => ({
    color: theme.colors.textButtons.disabled,
  }),
  cancelButtonTextStyle: theme => ({
    color: theme.colors.textColor,
    fontSize: 18,
    fontFamily: Fonts.type.VFFont,
    marginTop: 3,
  }),
  secureText: theme => ({
    width: '100%',
    marginLeft: 0,
    fontSize: 15,
    color: theme.colors.textColor,
  }),
  inputContainer: {
    marginHorizontal: 0,
  },
  addCardContainerStyle: {
    paddingHorizontal: 16,
    paddingTop: 10,
  },
  halfSizeContainer: {
    marginHorizontal: 0,
    width: '48%',
  },
});
